export default {
  validate (value, args) {
    const pattern = /^(\+)?(?:[0-9] ?){6,14}[0-9]$/;

    return value.match(pattern);
  },
};
